import * as Sentry from '@sentry/browser'

declare module globalThis {
  var ecomLogger: Logger
}

class Logger {
  readonly registry: Array<{
    time: number
    type: 'log' | 'error'
    messages: any[]
  }>

  constructor() {
    this.registry = []
    if (globalThis.ecomLogger) return globalThis.ecomLogger
    //@ts-ignore

    globalThis.ecomLogger = this
  }

  log(...args: any) {
    this.registry.push({
      time: Date.now(),
      type: 'log',
      messages: [...args]
    })
  }

  error(message: any) {
    Sentry.captureMessage(message)
    this.registry.push({
      time: Date.now(),
      type: 'error',
      messages: [message]
    })
  }

  getLog() {
    return this.registry
  }

  printLog() {
    console.group(`Ecom-Enzo ${process.env.REACT_APP_VERSION || 'of unknown version'}`)

    // @ts-ignore
    if (globalThis['@kodix/ecomEnzoRenderTime']?.length) {
      console.group('SSR Render times')
      // @ts-ignore
      globalThis['@kodix/ecomEnzoRenderTime'].forEach((entry: any) => {
        console.log(`${entry.stages}: ${new Date(parseInt(entry.time.toString(), 10))}`)
      })
      console.groupEnd()
    }

    this.registry.forEach((item) => {
      if (item.type === 'log') console.log(...item.messages)
      if (item.type === 'error') console.error(item.messages[0])
    })

    console.groupEnd()
  }
}

export const logger = new Logger()
